import { PatchBodyCertificationQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyCertification/patchBodyCertificationQuery.type';
import { patchBodyCertificationQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyCertification/patchBodyCertificationQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const patchBodyCertificationQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBodyCertificationQueryParamsType
> => ({
  mutationKey: ['PatchBodyCertificationQueryParamsType'],
  mutationFn: (params: PatchBodyCertificationQueryParamsType) =>
    patchBodyCertificationQueryFunction(params),
});
